@if(loggedIn) {
@if(isStaffOnly) {
<div class="dashboard">
    <div class="dashboard-grid">
        <div class="gc" style="grid-column: 1 / 3; grid-row: 1;">
            <div class="panel none">
                <h2>Good {{timeOfDay}}, {{userFirstName}}</h2>
                <p>This is your dashboard, check out what's new.</p>
            </div>
        </div>
        <div class="gc" style="grid-column: 3;">
            <app-cf-stat-panel [label]="'Outstanding Tasks'" [value]="'73'" [style]="StatPanelStyle.Warning">
            </app-cf-stat-panel>
        </div>
        <div class="gc" style="grid-column: 4;">
            <app-cf-stat-panel [label]="'New Applications'" [value]="'176'" [style]="StatPanelStyle.Todo">
            </app-cf-stat-panel>
        </div>
        <div class="gc" style="grid-column: 5;">
            <app-cf-stat-panel [label]="'Season 2026 Placements'" [value]="'2,605'" [style]="StatPanelStyle.Done">
            </app-cf-stat-panel>
        </div>
        <div class="gc" style="grid-column: 6;">
            <app-cf-stat-panel [label]="'UK Interviews Pending'" [value]="'34'" [style]="StatPanelStyle.Information">
            </app-cf-stat-panel>
        </div>

        <!-- New Row -->

        <div class="gc" style="grid-column: 1; grid-row: 2 / 8">
            <div class="panel none">
                <h3>Bookmarked</h3>
                <app-bookmark-display [showHeading]="false"></app-bookmark-display>
            </div>
        </div>

        <div class="gc" style="grid-column: 2 / 4; grid-row: 2 / 8">
            <div class="panel none">
                <h3>News Feed</h3>
                <app-news-feed></app-news-feed>
            </div>
        </div>

        <div class="gc" style="grid-column: 4 / 6; grid-row: 2 / 4">
            <div class="panel none">
                <h3>References Overview</h3>
                <div class="chart">
                    <div class="text">
                        <span class="label" style="grid-column: 1; grid-row: 1;">Awaiting approval</span><span
                            style="grid-column: 2; grid-row: 1;">50%</span>
                        <span class="label" style="grid-column: 1; grid-row: 2;">Authentication required</span><span
                            style="grid-column: 2; grid-row: 2;">25%</span>
                        <span class="label" style="grid-column: 1; grid-row: 3;">More info required</span><span
                            style="grid-column: 2; grid-row: 3;">25%</span>
                    </div>
                    <div class="pie"></div>
                </div>
            </div>
        </div>

        <div class="gc" style="grid-column: 6; grid-row: 2 / 8">
            <div class="panel none">
                <h3>Recently viewed</h3>
                <app-recently-viewed></app-recently-viewed>
            </div>
        </div>


        <div class="gc" style="grid-column: 4 / 6; grid-row: 4 / 8">
            <div class="panel none">
                <h3>Messages</h3>
                <app-received-message></app-received-message>
            </div>
        </div>
    </div>
</div>
} @else {
<div class="interviewer-alerts">
    @if (overdueLimitReached) {
    <div class="alert alert-danger">
        <strong>WARNING</strong> &mdash; You currently have overdue interview reports. To try and help you get caught up
        we have temporarily taken your interviewer profile offline to applicants.<br>
        As you know within the very competitive recruitment environment, we cannot have applications being delayed by
        late reports. Once you have submitted the missing reports your profile will automatically reactivate.<br>
        Please do contact the office if there is reason for the delay that you would like to discuss, you never know we
        might be able to help.<br>
        Many thanks.<br>
        CA Team.
    </div>
    }
</div>
<div class="info-card top-container">
    <div class="flex-child magenta">
        <app-bookmark-display></app-bookmark-display>
    </div>
    <div class="flex-child green">
    </div>
</div>

<div class="status">
    <div class="status-components">
        @if (!isOnlineInterviewer) {
        <div class="status-item upcoming info-card">
            <app-interview-ready-interviews [interviewerId]="selectedInterviewerId"></app-interview-ready-interviews>
        </div>
        }
        <div class="status-item upcoming info-card">
            <app-upcoming-interviews [interviewerId]="selectedInterviewerId" [showNextOverhead]="false"
                [showTime]="true" [compact]="true" [title]="'Upcoming Interviews'"></app-upcoming-interviews>
        </div>
        <div class="status-item incomplete info-card">
            <app-interview-report-incomplete [interviewerId]="selectedInterviewerId"></app-interview-report-incomplete>
        </div>
        @if (isInterviewer) {
        <div class="status-item completed info-card">
            <app-interview-report-rts [interviewerId]="selectedInterviewerId"></app-interview-report-rts>
        </div>
        }
        <!-- This was commented out as a part of CA-3325 - to restore the f2f collumn simply uncomment the code below -->
        <!-- @if (!isOnlineInterviewer) {
                <div class="status-item upcoming info-card">
                    <app-f2f-followup-interviews [interviewerId]="selectedInterviewerId"></app-f2f-followup-interviews>
                </div>
            } -->
    </div>
</div>
}
} @else {
<div>
    <p class="welcome">Welcome to Abeona</p>
    <p>Please sign-in.</p>
</div>
}